import moment from 'moment';
import { requestApi, API_END_POINT } from '../../common/api';
import { RESULT_CODE, DATE_TIME_FORMAT } from '../../common/const';
import { setErrorMessage, setErrPopMsg } from './CommonAction';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_USER_MANAGED_STATE = 'USER/SET_INIT_USER_MANAGED_STATE';

/**
 * state初期化
 */
export const setInitUserManagedState = () => ({
  type: SET_INIT_USER_MANAGED_STATE,
});

/**
 * 権限リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ROLE_LIST = 'USER/SET_ROLE_LIST';

/**
 * 権限リスト設定
 * @param   {string[]}  roleList 権限リスト
 */
export const setRoleList = (roleList) => ({
  type: SET_ROLE_LIST, roleList,
});

/**
 * パスワードリセット対象者設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_RESET_USER = 'USER/SET_RESET_USER';

/**
  * パスワードリセット対象者設定
  * @param   {string[]}  resetUser パスワードリセット対象者
  */
export const setResetUser = (resetUser) => ({
  type: SET_RESET_USER, resetUser,
});

/**
 * パスワードリセット対象者リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_RESET_USER_LIST = 'USER/SET_RESET_USER_LIST';

/**
 * パスワードリセット対象者リスト設定
 * @param   {string[]}  resetUserList パスワードリセット対象者リスト
 */
export const setResetUserList = (resetUserList) => ({
  type: SET_RESET_USER_LIST, resetUserList,
});

/**
 * 検索条件のユーザーID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_USER_ID = 'USER/SET_SEARCH_USER_ID';

/**
 * 検索条件のユーザーID設定
 * @param   {string}  searchUserId 検索条件のユーザID
 */
export const setSearchUserId = (searchUserId) => ({
  type: SET_SEARCH_USER_ID, searchUserId,
});

/**
 * 検索条件のユーザー名設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_USER_NAME = 'USER/SET_SEARCH_USER_NAME';

/**
 * 検索条件のユーザー名設定
 * @param   {string}  searchUserName 検索条件のユーザ名
 */
export const setSearchUserName = (searchUserName) => ({
  type: SET_SEARCH_USER_NAME, searchUserName,
});

/**
 * 検索条件の権限設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SEARCH_ROLE = 'USER/SET_SEARCH_ROLE';

/**
 * 検索条件の権限設定
 * @param   {string}  searchRole 検索条件の権限
 */
export const setSearchRole = (searchRole) => ({
  type: SET_SEARCH_ROLE, searchRole,
});

/**
 * 検索条件のソート項目設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SORT_ITEM = 'USER/SET_SORT_ITEM';

/**
 * 検索条件のソート項目設定
 * @param   {string}  sortItem 検索条件のソート項目
 */
export const setSortItem = (sortItem) => ({
  type: SET_SORT_ITEM, sortItem,
});

/**
 * 検索条件のソート順序設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SORT_ORDER = 'USER/SET_SORT_ORDER';

/**
 * 検索条件のソート順序設定
 * @param   {string}  sortOrder 検索条件のソート順序
 */
export const setSortOrder = (sortOrder) => ({
  type: SET_SORT_ORDER, sortOrder,
});

/**
 * 現在のページ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_NOW_PAGE = 'USER/SET_NOW_PAGE';

/**
 * 現在のページ設定
 * @param   {string}  nowPage 現在のページ
 */
export const setNowPage = (nowPage) => ({
  type: SET_NOW_PAGE, nowPage,
});

/**
 * 検索結果設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_USER_RESULT_LIST = 'USER/SET_USER_RESULT_LIST';

/**
 * 検索結果設定
 * @param   {object}  userResultList 検索結果
 */
export const setUserResultList = (userResultList) => ({
  type: SET_USER_RESULT_LIST, userResultList,
});

/**
 * 更新対象ユーザーID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPDATE_USER_ID = 'USER/SET_UPDATE_USER_ID';

/**
 * 更新対象ユーザーID設定
 * @param   {string}  updateUserId 更新対象ユーザID
 */
export const setUpdateUserId = (updateUserId) => ({
  type: SET_UPDATE_USER_ID, updateUserId,
});

/**
 * 更新後ユーザー名設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPDATE_USER_NAME = 'USER/SET_UPDATE_USER_NAME';

/**
 * 更新後ユーザー名設定
 * @param   {string}  updateUserName 新規ユーザ名
 */
export const setUpdateUserName = (updateUserName) => ({
  type: SET_UPDATE_USER_NAME, updateUserName,
});

/**
 * 更新対象の権限リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPDATE_ROLE_LIST = 'USER/SET_UPDATE_ROLE_LIST';

/**
 * 更新対象の権限リスト設定
 * @param   {string[]}  updateRoleList 更新対象の権限リスト
 */
export const setUpdateRoleList = (updateRoleList) => ({
  type: SET_UPDATE_ROLE_LIST, updateRoleList,
});

/**
 * 更新日時設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPDATE_DATE = 'USER/SET_UPDATE_DATE';

/**
 * 更新日時設定
 * @param   {string}  updateDate 更新日時
 */
export const setUpdateDate = (updateDate) => ({
  type: SET_UPDATE_DATE, updateDate,
});

/**
 * ユーザー情報変更POPUP表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_MODIFY_POP_FLG = 'USER/SET_MODIFY_POP_FLG';

/**
 * ユーザー情報変更POPUP表示フラグ設定
 * @param   {boolean}  modifyPopFlg ユーザ情報変更POPUP表示フラグ
 */
export const setModifyPopFlg = (modifyPopFlg) => ({
  type: SET_MODIFY_POP_FLG, modifyPopFlg,
});

/**
 * ユーザー情報変更POPUPで表示するエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MODIFY_POP_MESSAGE = 'USER/SET_ERR_MODIFY_POP_MESSAGE';

/**
 * ユーザー情報変更POPUP表示フラグ設定
 * @param   {string}  errModifyPopMessage ユーザ情報変更POPUP表示フラグ
 */
export const setErrModifyPopMessage = (errModifyPopMessage) => ({
  type: SET_ERR_MODIFY_POP_MESSAGE, errModifyPopMessage,
});

/**
 * パスワードリセットPOPUP表示フラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PASSWORD_RESET_POP_FLG = 'USER/SET_PASSWORD_RESET_POP_FLG';

/**
 * パスワードリセットPOPUP表示フラグ設定
 * @param   {boolean}  passwordResetPopFlg パスワードリセットPOPUP表示フラグ
 */
export const setPasswordResetPopFlg = (passwordResetPopFlg) => ({
  type: SET_PASSWORD_RESET_POP_FLG, passwordResetPopFlg,
});

/**
 * パスワードリセットPOPUPで表示するエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_PASSWORD_RESET_POP_MESSAGE = 'USER/SET_PASSWORD_RESET_POP_MESSAGE';

/**
 * パスワードリセットPOPUPメッセージ表示フラグ設定
 * @param   {string}  passwordResetPopMessage パスワードリセットPOPUPメッセージ表示フラグ
 */
export const setPasswordResetPopMessage = (passwordResetPopMessage) => ({
  type: SET_PASSWORD_RESET_POP_MESSAGE, passwordResetPopMessage,
});

/**
 * CSVファイルダウンロード
 * @param   {Dispatch} dispatch   actionを呼ぶための関数
 */
export const executeFileDownload = () => async (dispatch) => {
  // API実行
  const ret = await requestApi(dispatch, API_END_POINT.DOWNLOAD_ALL_USER, null, false, true);
  // エラーが発生した場合
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return false;
  }

  const array = [
    'usermaster_',
    moment().format(DATE_TIME_FORMAT.DATE_TIME_FULL_FILE),
    '.csv',
  ];
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = (array.join(''));
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();
  return true;
};

/**
 * ユーザーパスワード初期化
 * @param   {Dispatch} dispatch  actionを呼ぶための関数
 * @param {string[]} userList    パスワード初期化するユーザーのリスト
 * @param {string} initPassword    初期化パスワード
 */
export const executePasswordReset = (userList, initPassword) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    user_id: userList,
    password: initPassword,
  };
  // パスワード初期化実行
  const ret = await requestApi(dispatch, API_END_POINT.RESET_PASSWORD, o);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーの場合はメッセージ設定
    dispatch(setErrPopMsg(ret.response));
    return false;
  }
  // 正常終了の場合はtrueを返す
  return true;
};

/**
 * 検索条件をもとにユーザ情報を取得
 * @param   {Dispatch} dispatch         actionを呼ぶための関数
 * @param {string} searchUserId         ユーザーID
 * @param {string} searchUserName       ユーザー名
 * @param {string} searchRole           権限コード
 * @param {string} sortItem             ソート項目
 * @param {string} sortOrder            ソート順序
 * @param {*number} pageNumber          ページ番号
 */
export const searchUserList = (
  searchUserId, searchUserName, searchRole, sortItem, sortOrder, pageNumber,
) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    sort_item: sortItem,
    sort_order: sortOrder,
    page_no: pageNumber,
  };
  // ユーザーID
  if (searchUserId !== null && searchUserId.length > 0) {
    o.user_id = searchUserId;
  }
  // ユーザー名
  if (searchUserName !== null && searchUserName.length > 0) {
    o.user_name = searchUserName;
  }
  // 権限コード
  if (searchRole !== null && searchRole.length > 0) {
    o.role_code = searchRole;
  }
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.GET_USER_INFO, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    return null;
  }
  // 検索結果のセット
  return ret.response;
};

/**
 * ユーザー情報更新API
 * @param   {Dispatch} dispatch         actionを呼ぶための関数
 * @param {string} updateUserId         ユーザーID
 * @param {string} updateUserName       ユーザー名
 * @param {string} updateDate           更新日付
 */
export const updateUserInfo = (
  updateUserId, updateUserName, updateDate,
) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    user_id: updateUserId,
    user_name: updateUserName,
    update_datetime: updateDate,
  };
  // ユーザ情報更新API実行
  const ret = await requestApi(dispatch, API_END_POINT.UPDATE_USER_INFO, o);
  // エラーの場合はメッセージ設定
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrModifyPopMessage(ret.response));
    return false;
  }
  // 正常に終了した場合はtrueを返す
  return true;
};
